"use strict";

exports.__esModule = true;
exports.getCustomRoute = getCustomRoute;
exports.buildRoutesMap = buildRoutesMap;
exports.buildCustomUrl = void 0;

var _urlPattern = _interopRequireDefault(require("url-pattern"));

var _urlMapperUtils = require("@wix/url-mapper-utils");

var Routes = _interopRequireWildcard(require("../constants/routes"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function getCustomRoute(url) {
  for (var key in Routes) {
    var forumRoute = Routes[key];
    if (typeof forumRoute !== 'string') continue;
    var pattern = new _urlPattern["default"](forumRoute);
    var params = pattern.match(url);

    if (params) {
      var customRouteKey = mapRouteToCustomKey(forumRoute, params);
      return {
        customRouteKey: customRouteKey,
        params: params
      };
    }
  }

  return {};
}

function buildRoutesMap() {
  var _ref;

  var page = '**page**';
  var deepLinkData = '**deepLinkData**';
  var categorySlug = '**categorySlug**';
  var slug = '**categorySlug**';
  var postSlug = '**postSlug**';
  return _ref = {}, _ref[_urlMapperUtils.UrlMappingsKeys.FORUM_POST_PAGINATION_AND_DEEP_LINK_DATA] = {
    postSlug: postSlug,
    categorySlug: categorySlug,
    page: page,
    deepLinkData: deepLinkData
  }, _ref[_urlMapperUtils.UrlMappingsKeys.FORUM_POST_DEEP_LINK_DATA] = {
    postSlug: postSlug,
    categorySlug: categorySlug,
    deepLinkData: deepLinkData
  }, _ref[_urlMapperUtils.UrlMappingsKeys.FORUM_POST_PAGINATION] = {
    postSlug: postSlug,
    categorySlug: categorySlug,
    page: page
  }, _ref[_urlMapperUtils.UrlMappingsKeys.FORUM_POST] = {
    postSlug: postSlug,
    categorySlug: categorySlug
  }, _ref[_urlMapperUtils.UrlMappingsKeys.FORUM_POST_EDIT] = {
    postSlug: postSlug,
    categorySlug: categorySlug
  }, _ref[_urlMapperUtils.UrlMappingsKeys.FORUM_CATEGORY_PAGINATION] = {
    slug: slug,
    page: page
  }, _ref[_urlMapperUtils.UrlMappingsKeys.FORUM_CATEGORY] = {
    slug: slug
  }, _ref[_urlMapperUtils.UrlMappingsKeys.FORUM_CATEGORY_CREATE_POST] = {
    slug: slug
  }, _ref[_urlMapperUtils.UrlMappingsKeys.FORUM_CATEGORY_CREATE_QUESTION] = {
    slug: slug
  }, _ref;
}

function mapRouteToCustomKey(route, params) {
  switch (route) {
    case Routes.ROUTE_POST:
      if (params.page && params.deepLinkData) {
        return _urlMapperUtils.UrlMappingsKeys.FORUM_POST_PAGINATION_AND_DEEP_LINK_DATA;
      } else if (params.deepLinkData) {
        return _urlMapperUtils.UrlMappingsKeys.FORUM_POST_DEEP_LINK_DATA;
      } else if (params.page) {
        return _urlMapperUtils.UrlMappingsKeys.FORUM_POST_PAGINATION;
      } else {
        return _urlMapperUtils.UrlMappingsKeys.FORUM_POST;
      }

    case Routes.ROUTE_POST_EDIT:
      return _urlMapperUtils.UrlMappingsKeys.FORUM_POST_EDIT;

    case Routes.ROUTE_CATEGORY:
      return params.page ? _urlMapperUtils.UrlMappingsKeys.FORUM_CATEGORY_PAGINATION : _urlMapperUtils.UrlMappingsKeys.FORUM_CATEGORY;

    case Routes.ROUTE_CATEGORY_CREATE_POST:
      return _urlMapperUtils.UrlMappingsKeys.FORUM_CATEGORY_CREATE_POST;

    case Routes.ROUTE_CATEGORY_CREATE_QUESTION:
      return _urlMapperUtils.UrlMappingsKeys.FORUM_CATEGORY_CREATE_QUESTION;
  }
}

var buildCustomUrl = function buildCustomUrl(customRoutes, key, routeParams, removeSubstr) {
  if (routeParams === void 0) {
    routeParams = {};
  }

  var route = customRoutes[key] || '';

  for (var param in routeParams) {
    route = route.replace("**" + param + "**", routeParams[param]);
  }

  return removeSubstr ? route.replace(removeSubstr, '') : route;
};

exports.buildCustomUrl = buildCustomUrl;